import { createClient, type SupabaseClient } from "@supabase/supabase-js";

const url = import.meta.env.VITE_SUPABASE_URL as string | undefined;
const anon = import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined;

let client: SupabaseClient | null = null;

export function hasSupabaseConfig(): boolean {
  return Boolean(url?.trim() && anon?.trim());
}

export function getSupabase(): SupabaseClient | null {
  if (!hasSupabaseConfig()) return null;
  if (!client) {
    client = createClient(url!, anon!, {
      auth: {
        persistSession: true,
        autoRefreshToken: true,
      },
    });
  }
  return client;
}

/**
 * Short string for the Data tab when Supabase is off: shows what this bundle saw at build/dev start
 * (no secrets). Helps catch wrong `.env` path or missing `VITE_` prefix.
 */
export function supabaseEnvDebug(): string {
  const u = import.meta.env.VITE_SUPABASE_URL;
  const k = import.meta.env.VITE_SUPABASE_ANON_KEY;
  const urlSet = typeof u === "string" && u.trim().length > 0;
  const keySet = typeof k === "string" && k.trim().length > 0;
  const mode = import.meta.env.MODE;
  if (urlSet && keySet) return "This build has Supabase env vars; if features are still missing, hard-refresh or clear cache.";
  return `Diagnostic — this bundle (${mode}): VITE_SUPABASE_URL ${urlSet ? "set" : "missing"}, VITE_SUPABASE_ANON_KEY ${keySet ? "set" : "missing"}. (Independent of whether your Supabase project already has tables/data.)`;
}

/** Git commit baked into the static bundle at build time (empty locally unless env set). */
export function bundleBuildCommit(): string {
  const c = import.meta.env.VITE_BUILD_COMMIT;
  return typeof c === "string" && c.trim().length > 0 ? c.trim() : "";
}
